/**
 * Per-column header filters (double-click to search) — same pattern as Qawaem Console.
 */

export function applyColumnFilters(rows, filters, rules) {
  const list = Array.isArray(rows) ? rows : [];
  const ruleList = Array.isArray(rules) ? rules : [];
  const active = ruleList
    .map((rule) => ({ rule, value: String(filters?.[rule.key] ?? '').trim() }))
    .filter((entry) => entry.value);

  if (!active.length) return list;

  return list.filter((row) =>
    active.every(({ rule, value }) => {
      if (typeof rule.match === 'function') return rule.match(row, value);
      const cell = String(rule.getValue(row) ?? '');
      if (rule.mode === 'exact') return cell === value;
      return cell.toLowerCase().includes(value.toLowerCase());
    }),
  );
}

/** Shorthand for text columns */
export function textColumnRule(key, getValue) {
  return { key, getValue: getValue || ((row) => String(row?.[key] ?? '')) };
}

/** Shorthand for exact-match select columns (status, type, etc.) */
export function exactColumnRule(key, getValue) {
  return { key, getValue, mode: 'exact' };
}

export default applyColumnFilters;
